import React, { useState, useEffect, Fragment, useContext } from "react";
import CardDetail from "../components/CardDetail";
import Header from "../components/Header";
import Modal from "../components/Modal";
import Wall from "../components/Wall";

import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";
import YearFormDetail from "../components/YearFormDetail";
import { IYear } from "../models/year";


const WallPage:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);
  const {cardChosen, card2Chosen, setCardChosen, setCard2Chosen} = rootStore.cardsStore;
  const {yearClickedOpen, setYearClickedOpen}: {yearClickedOpen: IYear, setYearClickedOpen: Function} = rootStore.yearsStore;

  const closeCardModal = () => {
    setCardChosen(null);
  }

  const closeYearModal = () => {
    setYearClickedOpen(null);
  }

  return (
    <Fragment>
      <Header />
      <Wall />
      <Modal isOpen={cardChosen != null} closeModal={closeCardModal} columns={(card2Chosen === null) ? 1 : 2}>
        <CardDetail cardChosen={cardChosen} position={1} changeCard={setCard2Chosen} />
        {card2Chosen != null &&
          <CardDetail cardChosen={card2Chosen} position={2} changeCard={setCard2Chosen} />
        }
      </Modal>
      {yearClickedOpen && yearClickedOpen.slug}

      <Modal isOpen={yearClickedOpen != null} closeModal={closeYearModal} columns={1}>
        <YearFormDetail formChosen={yearClickedOpen} />
      </Modal>
    </Fragment>
  )
});

export default WallPage;
